import { render } from "./BuyNavigation.vue?vue&type=template&id=42ee7498"
import script from "./BuyNavigation.vue?vue&type=script&lang=js"
export * from "./BuyNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__